export default "__VITE_ASSET__5iqozE0W__"